export default __webpack_public_path__ + "static/media/gold@3x.bf4cef8a.png";